import cx from 'classnames';
import React, { ReactNode } from 'react';

import { LessonPassportSkeleton } from './__skeleton/lesson-passport__skeleton';

import './lesson-passport.scss';

interface Props {
    children: ReactNode | ReactNode[];
    mix?: string;
    isSkeleton: boolean;
}

export const LessonPassport = ({ children, mix, isSkeleton }: Props) => {
    if (isSkeleton) {
        return (
            <div className={cx('lesson-passport', mix)}>
                <LessonPassportSkeleton />
            </div>
        );
    }

    return <div className={cx('lesson-passport', mix)}>{children}</div>;
};

export { LessonPassportBadge, LESSON_PASSPORT_BADGE_THEME } from './__badge/lesson-passport__badge';
export { LessonPassportButton } from './__button/lesson-passport__button';
export { LessonPassportFooter } from './__footer/lesson-passport__footer';
export { LessonPassportHeader } from './__header/lesson-passport__header';
export { LessonPassportInfoItem } from './__info-item/lesson-passport__info-item';
export { LessonPassportTip, LESSON_PASSPORT_TIP_THEME } from './__tip/lesson-passport__tip';
